import { getAttributionParams } from "../lib/analytics";

const DEFAULT_GOMODERN_DEMO_URL = "https://link.moderncrm.org/widget/form/Xa3w1slN3Cx78i0byy6W";

function isPrerendering() {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent === "ReactSnap"
  );
}

function readPublicEnv(key) {
  if (typeof window !== "undefined") {
    if (window.__ENV__ && typeof window.__ENV__[key] === "string" && window.__ENV__[key]) {
      return window.__ENV__[key];
    }

    if (typeof window[key] === "string" && window[key]) {
      return window[key];
    }
  }

  if (typeof process !== "undefined" && process.env) {
    if (typeof process.env[key] === "string" && process.env[key]) {
      return process.env[key];
    }

    const craAlias = key.startsWith("VITE_") ? `REACT_APP_${key.slice(5)}` : null;
    if (craAlias && typeof process.env[craAlias] === "string" && process.env[craAlias]) {
      return process.env[craAlias];
    }
  }

  return "";
}

export function getGoModernUrls() {
  const demo = readPublicEnv("VITE_GOMODERN_DEMO_URL") || DEFAULT_GOMODERN_DEMO_URL;
  const cro = readPublicEnv("VITE_GOMODERN_CRO_DEMO_URL") || demo;
  const founder = readPublicEnv("VITE_GOMODERN_FOUNDER_DEMO_URL") || demo;
  const services = readPublicEnv("VITE_GOMODERN_SERVICES_CALL_URL") || demo;

  return {
    demo,
    cro,
    founder,
    services,
  };
}

export function getSourcePageFromLocation(location) {
  const pathname = location?.pathname || "/home";
  const hash = location?.hash || "";

  if (pathname === "/" || pathname === "/home") {
    if (hash === "#for-cros") {
      return "for_cros";
    }
    if (hash === "#for-founders") {
      return "for_founders";
    }
    if (hash === "#book-demo") {
      return "book_demo";
    }
    return "home";
  }

  return pathname.replace(/^\/+/, "").replace(/-/g, "_") || "home";
}

export function buildGoModernBookingUrl({
  baseUrl,
  sourcePage,
  ctaClicked,
  requestedOffer,
  buyerType,
}) {
  const resolvedBaseUrl = baseUrl || DEFAULT_GOMODERN_DEMO_URL;
  const bookingUrl = new URL(resolvedBaseUrl);

  if (isPrerendering()) {
    return bookingUrl.toString();
  }

  const attribution = getAttributionParams();

  const valueMap = {
    source: "bestsalescoach_website",
    source_page: sourcePage,
    cta_clicked: ctaClicked,
    requested_offer: requestedOffer,
    buyer_type: buyerType,
    session_id: attribution.session_id,
    landing_page: attribution.landing_page,
    current_page: attribution.current_page,
    referrer: attribution.referrer,
    utm_source: attribution.utm_source,
    utm_medium: attribution.utm_medium,
    utm_campaign: attribution.utm_campaign,
    utm_content: attribution.utm_content,
    utm_term: attribution.utm_term,
  };

  Object.entries(valueMap).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      bookingUrl.searchParams.set(key, value);
    }
  });

  return bookingUrl.toString();
}
